import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import StepOneForm from './form';
import style from '../styles/style.module.css';

class StepOne extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className={ `${ style.stepOne } ${ style.listCreationStep }` }>
                <div className={ style.titleBar }>
                    <h2>{ this.props.title }</h2>
                </div>
                <div className={ style.stepContent }>
                    <StepOneForm onSubmit={ this.props.onSubmit } />
                </div>
            </div>
        );
    }
}
StepOne.defaultProps = {
    onSubmit: ()=>{},
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        ownLists: state.self.lists,
    };
};

export default connect( mapStateToProps )( StepOne );
